import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbPopoverConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DevelopmentInterface } from 'src/app/shared/interfaces/DevelopmentInterface';

@Component({
  selector: 'app-files-table',
  templateUrl: './files-table.component.html',
  styleUrls: ['./files-table.component.scss'],
  providers: [NgbPopoverConfig],
})
export class FilesTableComponent implements AfterViewInit {
  displayedColumns: string[] = [
    'number',
    'title',
    'createdAt',
    'updatedAt',
    'operations',
  ];
  public selectedDevelopment = -1;
  public orderAsc = true;

  @Input() dataSource: MatTableDataSource<DevelopmentInterface>;
  @Output() private emitOnFilterService = new EventEmitter<string>();
  @Output() private emitOnSortService = new EventEmitter<string>();
  @Output() private emitOnSelectDevelopmentService = new EventEmitter<string>();
  @Output() private emitOnDeleteDevelopmentService = new EventEmitter<number>();
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private modalService: NgbModal,
    private config: NgbPopoverConfig
  ) {
    this.config.placement = 'top';
    this.config.triggers = 'hover';
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  private getModalOptions(
    size: string = 'lg',
    centered: boolean = true,
    backdrop: boolean = true,
    backdropClass: string = 'customBackdrop'
  ): NgbModalOptions {
    return {
      size,
      centered,
      backdrop,
      backdropClass,
    };
  }

  public openModal(templateRef: TemplateRef<any>, selectedId?: string): void {
    if (selectedId) {
      this.selectedDevelopment = parseInt(selectedId, 0);
    }
    this.modalService.open(templateRef, this.getModalOptions());
  }

  public selectDevelopment(developmentId: number): void {
    this.emitOnSelectDevelopmentService.emit(developmentId.toString());
  }

  public deleteDevelopment(): void {
    this.emitOnDeleteDevelopmentService.emit(this.selectedDevelopment);
  }

  public applyFilter(filterValue: string): void {
    this.emitOnFilterService.emit(filterValue);
  }

  public sortData(sortType: string): void {
    this.emitOnSortService.emit(sortType);
  }
}
